import videojs from 'video.js';

export default class PlaycoverContentWrapper extends videojs.getComponent('Component') {
    /**
     * 
     * @param {videojs.Player} player
     */
    constructor(player, options) {
        super(player, options);
    }

    createEl(tag, props = {}, attributes = {}) {
        tag = 'div';
        props = Object.assign({
            className: 'mediasite-player__playcover-content-wrapper'
        });

        return super.createEl.call(this, tag, props, attributes);
    }
}